export const NormalInputStyle = {height: "auto", borderRadius: "0px"}